import React,{useState,useEffect} from 'react'
import img1 from "../images/Hero.jpg";

const Hero = () => {
   const [index, setIndex] = useState(0);
  const letters = ['P', 'R', ' ', 'S', 'i', 'l', 'k', 's'];

  useEffect(() => {
    const timer = setInterval(() => {
      setIndex((prevIndex) => {
        if (prevIndex < letters.length - 1) {
          return prevIndex + 1;
        } else {
          // Reset index to 0 after displaying all letters
          return 0;
        }
      });
    }, 500); // Adjust the delay between each letter appearance

    return () => clearInterval(timer); // Cleanup on unmount
  }, [letters.length]); // Include letters.length in the dependency array

  return (
    <div className="relative w-full  -mt-24 2xl:mt-20 8xl:mt-32 10xl:mt-44 11xl:mt-56 h-[500px] 8xl:h-[550px] 10xl:h-[840px] 11xl:h-[930px]">
      <img
        src={img1}
        alt="Banner"
        className="w-full h-full  object-cover"
         loading="lazy"
      />

      {/* Centered content */}
      <div className="absolute inset-0 flex flex-col items-center justify-center text-[#fff] text-center px-4 5xl:px-12 6xl:px-36 7xl:px-48 8xl:px-56 9xl:px-60 10xl:px-72 11xl:px-96">
        <h1 className="md:text-3xl lg:text-5xl font-lexendgiga  text-[20px] md:text-[30px] lg:text-[40px] 8xl:text-[50px] 9xl:text-[65px] 10xl:text-[80px] 11xl:text-[100px]">
          "Celebrate Tradition with&nbsp;
          {letters.map((letter, i) => (
            <span key={i} className='text-[#fdfa2d]' style={{ display: i <= index ? 'inline' : 'none' }}>
              {letter}
            </span>
          ))}
          &rsquo; Exclusive Thiruppuvanam Collection."
        </h1>
       
         <a 
         className="mt-6 px-6 py-2 8xl:px-8 8xl:py-4 border-2  border-white text-white font-bold rounded 6xl:text-lg 8xl:text-xl 8xl:border-5 9xl:text-2xl 10xl:text-3xl 11xl:text-5xl"
            href="https://api.whatsapp.com/send?phone=919363799534&text=I%20am%20interested%20in%20the%20Thiruppuvanam%20Collection."
            target="_blank"
            rel="noopener noreferrer"
          >
          Explore Now
          </a>
      </div>
    </div>
  );
};

export default Hero;
